var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 troubleshoot-main",attrs:{"id":_vm.questionId}},[_vm._t("default",null,{"id":"pageContent"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }